module.exports = __webpack_public_path__ + "img/icon-network.0411b7d4.svg";